import React from 'react';
import ActivatableToolButton from 'app/components/ToolsBar/ActivatableToolButton';

export default (props) => {
  const { produceImageToolsList } = props;

  const disableNorbergOlssonOnActivation = (newState) => {
    if (newState !== 'active') return;
    produceImageToolsList((draftToolsList) => {
      if (draftToolsList.NorbergOlsson === undefined) return;
      draftToolsList.NorbergOlsson.state = 'disabled';
    });
  };

  return (
    <ActivatableToolButton
      icon="distraction-index"
      tooltipId="tools.distraction_index.tooltip"
      disabledState="disabled"
      setToolStateFn={disableNorbergOlssonOnActivation}
      {...props}
    />
  );
};
